import React, { useState } from "react";
import { DialogWrapper, DialogWrapperProps } from "components/shared/dialog";
import { Box, IconButton, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { RegularFileImport } from "./regular-import";
import { EmbededFileImport } from "./embeded-import";
import { UploadType } from "store/url-builder";
import { uploadContent, uploadContentEmbeded } from "adapters";
import { FileReader } from "components/shared/file-reader";
import { HighlightOffOutlined } from "@material-ui/icons";
import { theme } from "material-theme";
import { uploadFile } from "adapters/public-card";
import { useParams } from "react-router-dom";

export interface FileImportDialogProps extends DialogWrapperProps {
  onFileUploaded(file: UploadType): void;
  onFileRemoved?(): void;
  preselectfile?: UploadType;
}

export const FileImportDialog = (props: FileImportDialogProps) => {
  const [tab, setTab] = useState("1");
  const [selectedFile, setSelectedFile] = useState<UploadType | File>();

  const { cardId }: any = useParams();

  const submit = () => {
    if (!selectedFile) return;

    switch (tab) {
      case "1": // regular file
        Promise.resolve().then(() => {
          // create dummy file
          const _file = new File([""], (selectedFile as File).name, {
            type: (selectedFile as File).type,
          });

          uploadContent(_file).then(async (response) => {
            if (response.data.success) {
              await uploadFile(
                cardId,
                selectedFile as File,
                response.data
              ).then((response) => {
                if (response.data.success)
                  props.onFileUploaded(response.data.data as UploadType);
              });
            }
          });
        });

        break;
      case "2": // embeded file
        uploadContentEmbeded(selectedFile as UploadType).then((response) => {
          if (response.status === 200)
            props.onFileUploaded(response.data.data as UploadType);
        });
        break;
    }
  };

  return (
    <DialogWrapper
      {...props}
      title={props.title || "Import file"}
      onSubmit={submit}
      onClose={(event, reason) => {
        if (reason && reason === "backdropClick") return false;
        if (props.onClose) props?.onClose(event, reason);
      }}
    >
      {props.preselectfile &&
        props.preselectfile.mimeType !== "Empty placeholder" && (
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "20em",
              display: "flex",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 0,
                zIndex: 2,
                right: 0,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <IconButton onClick={props.onFileRemoved}>
                <HighlightOffOutlined
                  style={{ color: theme.palette.error.main }}
                />
              </IconButton>
            </Box>
            <FileReader
              file={props.preselectfile}
              videoConfig={{ controls: true }}
            />
          </Box>
        )}

      {(!props.preselectfile ||
        props.preselectfile.mimeType === "Empty placeholder") && (
        <Box sx={{ width: "100%" }}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={(e, newTab) => setTab(newTab)}
                centered
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
              >
                <Tab label="Upload Image" value="1" />
                <Tab label="Place Public Video URL Link" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <RegularFileImport onFileChanged={setSelectedFile} />
            </TabPanel>
            <TabPanel value="2">
              <EmbededFileImport onFileChanged={setSelectedFile} />
            </TabPanel>
          </TabContext>
        </Box>
      )}
    </DialogWrapper>
  );
};
